module.exports = __webpack_public_path__ + "img/IMG_0214.52177e97.jpg";